import React from 'react';
import useAuth from 'Modules/firebase/use-auth';
import { useSearchParams } from 'react-router-dom';

import WavingHandOutlined from '@mui/icons-material/WavingHandOutlined';
import Typography from '@mui/material/Typography';
import { styled, Button } from '@mui/material';

import BackgroundImage from '../../components/general/BackgroundImage';
import { StyledTwoScreensWrapper } from '../../components/modules/AuthPage/Styles';
import { MessageWithTipMui } from '../../components/modules/AuthPage/setup/MessageWithTipMui';
import welcomeImage from '@/operator/public/assets/images/background/welcome.svg';
import { getSubDomain } from '../../utils/domain';
import { appRoutes } from '@/routes/constants';
import { useSubdomain } from "hooks/useSubdomain";

const StyledPurpleButton = styled(Button)(() => ({
    backgroundColor: '#4c17ad',
    padding: '8px 15px',

    '&:disabled': {
        backgroundColor: '#bf9dff ',
        color: 'white',
    },
    '&:hover': {
        backgroundColor: '#4c17ad',
    },
    minWidth: '8px',
    minHeight: '25px',
    color: '#ffffff',
    textTransform: 'none',

    '@media (width <= 850px)': {
        width: '100%',
        justifyContent: 'center',
    },
}));

const Description = () => {
    const { loginWithRedirect } = useAuth();

    const [searchParams] = useSearchParams();
    const invitation = searchParams.get('invitation') || undefined;
    const email = searchParams.get('email') || undefined;

    const {subdomain: organization} = useSubdomain();
    
    return (
        <>
            <Typography variant="body1">
                We were wondering when you would RSVP. You’ve been invited by{' '}
                <strong>{organization}</strong> to join them on Operator.
            </Typography>
            <Typography variant="body1">
                Just sign in and we can get you started.
            </Typography>
            <StyledPurpleButton
                variant="contained"
                onClick={() =>
                    loginWithRedirect({
                        appState: {
                            targetUrl: appRoutes.AUTH_SETUP_ONBOARDING,
                        },
                        authorizationParams: {
                            invitation,
                            email,
                        },
                    })
                }
                style={{ justifyContent: 'center' }}
            >
                Sign In
            </StyledPurpleButton>
        </>
    );
};

const YouMadeItPage = (): JSX.Element => {
    return (
        <StyledTwoScreensWrapper>
            <MessageWithTipMui
                Icon={WavingHandOutlined}
                headlineVariant="h2"
                headline="Ohh... hey, you made it!"
                description={<Description />}
            />

            <BackgroundImage src={welcomeImage} />
        </StyledTwoScreensWrapper>
    );
};

export default YouMadeItPage;
